module.exports = __webpack_public_path__ + "media/images/icon/icon_normal-c8e5f375c918ede8a153c06736203b18.png";